import api from '@/libs/axios'
import { ShortAdvancedContrat } from '../models/contrats/advancedContrat';

const resource = 'AdvancedContrats'

export default class AdvancedContratsResource {
  public async paginatedList(
    pagenumber?: number,
    pagesize?: number,
    orderBy?: string,
    orderByDescending?: boolean,
    search?: string,
    typePrestation?: string,
    responsableId?: string,
    typeContrat?: string,
    dateDebutApres?: string,
    dateDebutAvant?: string,
    dateFinApres?: string,
    dateFinAvant?: string
  ) : Promise<ShortAdvancedContrat[]> {
    const params = new URLSearchParams();

    if (pagenumber) params.append("PageNumber", pagenumber.toString());
    if (pagesize) params.append("PageSize", pagesize.toString());
    if (orderBy) params.append("OrderBy", orderBy.toString());
    if (orderByDescending)
      params.append("OrderByDescending", orderByDescending.toString());
    if (search) params.append("Search", search);
    if (typePrestation) params.append("TypePrestation", typePrestation);
    if (responsableId) params.append("ResponsableId", responsableId);
    if (typeContrat) params.append("TypeContrat", typeContrat);
    if (dateDebutApres) params.append("DateDebutApres", dateDebutApres);
    if (dateDebutAvant) params.append("DateDebutAvant", dateDebutAvant);
    if (dateFinApres) params.append("DateFinApres", dateFinApres);
    if (dateFinAvant) params.append("DateFinAvant", dateFinAvant);

    const response = await api.get(`${resource}`, { params: params })
    return response.data
  }
}
